// widget/src/cart-context.tsx
import { createContext, useContext } from "react"

export interface CartApi {
  addToCart: (variantId: string, quantity?: number) => void | Promise<void>
}

const noop: CartApi = { addToCart: () => {} }
export const CartContext = createContext<CartApi>(noop)
export const useCart = () => useContext(CartContext)
